import { PublicTransmedRegistration } from "../../../../dtos/transmed/process/registration/registration";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../../..";
import TransmedPaymentApi from "../../../../api/transmed/payment";
import {
  TransmedRegistrationPaymentProofInput,
  TransmedRegistrationPaymentProofValidationInput,
} from "../../../../dtos/transmed/process/registration/payment";

class TransmedRegistrationPaymentServiceReader extends ServiceReader {
  public async incomings(): Promise<PublicTransmedRegistration[]> {
    return await new TransmedPaymentApi().get();
  }
}

class TransmedRegistrationPaymentServiceCreator extends ServiceCreator {
  public async upload(proof: File): Promise<void> {
    return await new TransmedPaymentApi().post(
      new TransmedRegistrationPaymentProofInput(proof)
    );
  }
}

class TransmedRegistrationPaymentServiceUpdater extends ServiceUpdater {
  public async validate(id: number): Promise<void> {
    return await new TransmedPaymentApi().put(
      `${id}`,
      new TransmedRegistrationPaymentProofValidationInput(true)
    );
  }

  public async reject(id: number, message: string): Promise<void> {
    return await new TransmedPaymentApi().put(
      `${id}`,
      new TransmedRegistrationPaymentProofValidationInput(false, message)
    );
  }
}

class TransmedRegistrationPaymentServiceDeleter extends ServiceDeleter {}

export default class TransmedRegistrationPaymentService extends Service {
  public get read(): TransmedRegistrationPaymentServiceReader {
    return new TransmedRegistrationPaymentServiceReader();
  }
  public get create(): TransmedRegistrationPaymentServiceCreator {
    return new TransmedRegistrationPaymentServiceCreator();
  }
  public get update(): TransmedRegistrationPaymentServiceUpdater {
    return new TransmedRegistrationPaymentServiceUpdater();
  }
  public get delete(): TransmedRegistrationPaymentServiceDeleter {
    return new TransmedRegistrationPaymentServiceDeleter();
  }
}
